import React from 'react';
import { DESTINATIONS } from '../../serviceStart.js';

// Where a process came from: the accepted proposal and line it was prepared from
// (src/serviceStart.js). Only the quote's name and line, never commercial notes.
// The request and the opportunity are reached through the proposal (Pipeline).
const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString('es', { day: 'numeric', month: 'short', year: 'numeric' }) : '');

export default function OriginNote({ origins = [] }) {
  const list = [].concat(origins).filter(Boolean);
  if (!list.length) return null;
  return (
    <div style={{ fontSize: 12, color: 'var(--globant-muted)', lineHeight: 1.5, padding: '8px 10px', border: '1px dashed var(--globant-border)', borderRadius: 8, marginBottom: 12, display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
      <span>
        {list.map((o, i) => (
          <span key={i}>{i ? ' · ' : ''}Origen{list.length > 1 ? ` (${DESTINATIONS[o.destination]?.label || o.destination})` : ''}: propuesta «{o.quoteName || 'sin nombre'}», línea «{o.service}», {o.mode === 'linked' ? 'vinculado' : 'preparado'} el {fmt(o.at)}</span>
        ))}
        . Preparar no marca que el servicio empezó.
      </span>
      <button type="button" className="action-btn" style={{ fontSize: 11, padding: '2px 8px' }}
        onClick={() => window.dispatchEvent(new CustomEvent('oike:navigate', { detail: { page: 'proposals' } }))}>Ver en el pipeline</button>
    </div>
  );
}
